<script lang="ts">
	import { fade } from 'svelte/transition';

	import { readFragment, type FragmentOf } from '$lib/graphql';

	import { PhotographPhotographFragment } from './PhotographPhotograph.fragment';

	type Props = { photograph: FragmentOf<typeof PhotographPhotographFragment> };

	let props: Props = $props();

	let photograph = $derived(readFragment(PhotographPhotographFragment, props.photograph));
</script>

{#if photograph.responsiveImage}
	<img
		class="mx-auto text-transparent object-contain"
		style="max-height: 100vh; max-height: 100lvh; grid-column: 1; grid-row: 1;"
		src={photograph.responsiveImage.src}
		sizes={photograph.responsiveImage.sizes}
		srcset={photograph.responsiveImage.srcSet}
		alt={photograph.responsiveImage.alt}
		loading="eager"
		decoding="async"
		width={photograph.responsiveImage.width}
		height={photograph.responsiveImage.height}
		transition:fade
	/>
{/if}
